import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { LazyRoute } from "./LazyRoute";
import { LazyRouteListProps } from "./interface";
import RouteConfigContext from "./context";

export const LazyRouteList = ({
  routeConfig,
  rootPath,
  mainUrl: defaultMainUrl,
}: LazyRouteListProps) => {
  const pathname = window.location.pathname;
  const mainUrl =
    defaultMainUrl || pathname.substring(pathname.indexOf("/", 1));
  console.log(mainUrl, "mainUrl");
  return (
    <Router>
      <Switch>
        <Route exact path="/" render={() => <Redirect to={mainUrl} />} />
        <RouteConfigContext.Provider value={{ rootPath, viewPath: "" }}>
          {routeConfig?.map((item) => (
            <LazyRoute key={item.path} {...item} />
          ))}
        </RouteConfigContext.Provider>
      </Switch>
    </Router>
  );
};
